import React from "react";
import { TouchableOpacity, View } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function MacIcon(props) {
  const width = props.width || 36;
  const height = props.height || 36;

  const TAG = props.onPress ? TouchableOpacity : View;

  return (
    <TAG style={props.styles} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M32.0596 25.02C31.2833 26.744 30.9093 27.5147 29.9108 29.0362C28.513 31.1625 26.5415 33.8175 24.1058 33.8343C21.9374 33.854 21.3777 32.4197 18.433 32.445C15.4912 32.459 14.878 33.8625 12.7068 33.84C10.2683 33.8175 8.40366 31.4268 7.00585 29.3034C3.09647 23.3493 2.68303 16.3687 5.09897 12.6562C6.80897 10.0237 9.51178 8.47685 12.0515 8.47685C14.639 8.47685 16.2646 9.89716 18.4021 9.89716C20.4777 9.89716 21.7405 8.47403 24.733 8.47403C26.9943 8.47403 29.3849 9.70591 31.0949 11.8322C25.5037 14.8978 26.4121 22.8825 32.0596 25.02ZM22.4605 6.09747C23.549 4.69966 24.3758 2.7281 24.0749 0.719971C22.3002 0.840908 20.2246 1.97435 19.0124 3.44247C17.9127 4.78122 17.0015 6.76685 17.3558 8.68778C19.2937 8.74966 21.299 7.59372 22.4605 6.09747Z"
          fill="black"
        />
      </Svg>
    </TAG>
  );
}
